module.exports = __webpack_public_path__ + "img/TestScore.5daade60.svg";